import DriverAssetIssuanceTracking from "../../../views/DriverAssetIssuanceTracking";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverAssetIssuanceTrackingRoutes = [
  {
    menuName: MenuNames.DRIVER_ASSET_ISSUANCE_TRACKING,
    path: "/driver-asset-issuance-tracking",
    component: DriverAssetIssuanceTracking,
    exact: true,
  },
];

export default DriverAssetIssuanceTrackingRoutes;
